import { render, staticRenderFns } from "./MealOrdered.vue?vue&type=template&id=0361a15f&scoped=true&"
import script from "./MealOrdered.vue?vue&type=script&lang=js&"
export * from "./MealOrdered.vue?vue&type=script&lang=js&"
import style0 from "./MealOrdered.vue?vue&type=style&index=0&id=0361a15f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361a15f",
  null
  
)

export default component.exports